import { Button } from "@tfg/ui"

import { useGetOrganizationQuery } from "~/pages/Admin/Organizations/hooks"
import { useToggleUserActiveStatusMutation } from "~/pages/Admin/Organizations/hooks/useToggleUserStatusHook"

type ToggleUserStatusButtonProps = {
  companyId: string
  organizationId: number
  user: {
    id: string
    email: string
    name: string
    active: boolean
  }
}

export const ToggleUserStatusButton = ({
  companyId,
  organizationId,
  user,
}: ToggleUserStatusButtonProps) => {
  const { mutateAsync: toggleUserStatus } = useToggleUserActiveStatusMutation()
  const { refetch } = useGetOrganizationQuery(organizationId)
  const isActive = user.active

  const handleToggleUserStatus = async (isActive: boolean) => {
    await toggleUserStatus({
      ...user,
      active: isActive,
      companyId,
    })
    refetch()
  }

  const buttonText = isActive ? "Deactivate user" : "Activate user"
  const testId = isActive ? "deactivate-user" : "activate-user"

  return (
    <Button
      size="sm"
      variant="primary"
      fullWidth={false}
      data-user-email={user.email}
      data-testid={testId}
      onClick={() => handleToggleUserStatus(!isActive)}
    >
      {buttonText}
    </Button>
  )
}
